/**
 * 店铺授权回调：thread/lib/websocket.js 里 message.invoke("vue@xxxAuthCallBack", { __renderer: true })
 * 必须在 main.js 全局 bindBy，不能只在弹窗 show() 时绑定，否则子进程推过来时渲染层没有监听。
 */
export function installShopAuthRecvBridge(eapi) {
    if (!eapi || typeof eapi.bindBy !== "function") {
        return;
    }
    const map = {
        "vue@shopAuthCallBack": "shop-auth-callback-shopee",
        "vue@lazadaAuthCallBack": "shop-auth-callback-lazada",
        "vue@tiktokAuthCallBack": "shop-auth-callback-tiktok",
    };
    Object.keys(map).forEach((action) => {
        eapi.bindBy(
            action,
            async (params, call) => {
                try {
                    if (window.vue) {
                        window.vue.$emit(map[action], params);
                    }
                } finally {
                    call({ code: 1, msg: "ok" });
                }
            },
            true
        );
    });
}
